module.exports = __webpack_public_path__ + "static/img/electrode-pad.3eebc932.png";